module.exports = __webpack_public_path__ + "static/media/sf_restaurant_12.61503cef.jpg";